import { useMutation, useQueryClient } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';

export const DELETE_CAMPAIGN_MK = 'deleteCampaignMK';

interface DeleteCampaignParams {
  campaignId: string;
}

const deleteCampaign = ({ campaignId }: DeleteCampaignParams) => {
  return authFetch(`/Adviser/Campaigns/Delete/${campaignId}`, {
    method: 'DELETE',
  });
};

export const useDeleteCampaignMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteCampaign, {
    mutationKey: DELETE_CAMPAIGN_MK,

    onSuccess: async () => {
      queryClient.invalidateQueries(queryKeys.campaigns());
    },
  });
};
